export default __webpack_public_path__ + "static/media/pay.1ae9c40e.svg";